import { ENV as ENVType, APP as APPType, FieldTypes } from '@/types/types';
import quickSignerLogo from '../assets/logo-quicksigner.png';
import eSemneazaLogo from '../assets/logo-esemneaza.svg';
import { Extensions } from '@/utils/extToMimeType';

export const APP = import.meta.env.REACT_APP_APP as APPType;
export const ENV = import.meta.env.REACT_APP_ENV as ENVType;

export const STRIPE_PUB_KEY = import.meta.env
    .REACT_APP_STRIPE_PUB_KEY as string;

// export const ROPROD_GA_ID = 'G-1HP5071VKV';

// export const initialFieldSize = {
//     [FieldTypes.SIGNATURE]: {
//         width: 150,
//         height: 70,
//     },
//     [FieldTypes.TEXT]: {
//         width: 150,
//         height: 30,
//     },
//     [FieldTypes.STAMP]: {
//         width: 120,
//         height: 80,
//     },
// };

export const recipientColors = [
    '#FDDCAB5C',
    '#D9D6FE5C',
    '#FECDD65C',
    '#C7D7FE5C',
    '#FCCEEE5C',
    '#B9E6FE5C',
    '#D5D9EB5C',
    '#A6F4C55C',
];

export const recipientBorderColors = [
    '#FDDCAB',
    '#D9D6FE',
    '#FECDD6',
    '#C7D7FE',
    '#FCCEEE',
    '#B9E6FE',
    '#D5D9EB',
    '#A6F4C5',
];

export const FILL_TEXT_HEIGHT_RATIO = window.innerWidth < 1025 ? 0.5 : 0.75;

export const FONT_FAMILIES = {
    COURIER: '"Courier Prime", monospace',
    SABILA: 'bold',
};

export type FontFamilyValue =
    (typeof FONT_FAMILIES)[keyof typeof FONT_FAMILIES];

export const FIELD_FONT_FAMILY = {
    [FieldTypes.SIGNATURE]: FONT_FAMILIES.SABILA,
    [FieldTypes.INITIALS]: FONT_FAMILIES.SABILA,
    [FieldTypes.TEXT]: FONT_FAMILIES.COURIER,
    [FieldTypes.TEXTAREA]: FONT_FAMILIES.COURIER,
    [FieldTypes.DATE]: FONT_FAMILIES.COURIER,
    [FieldTypes.STAMP]: FONT_FAMILIES.COURIER,
    [FieldTypes.CHECKBOX]: '',
    [FieldTypes.FILE]: FONT_FAMILIES.COURIER,
};

export const TEXTAREA_STYLE = {
    MOBILE: {
        fontSize: 6,
        lineHeight: 7,
        padding: 3,
    },
    DESKTOP: {
        fontSize: 14,
        lineHeight: 16,
        padding: 3,
    },
};

export const FILE_ATTACH_ALLOWED_EXTS: Extensions[] = [
    'jpg',
    'jpeg',
    'png',
    'doc',
    'docx',
    'pdf',
    'txt',
    'odt',
    'rtf',
    'xls',
    'xlsx',
    'ods',
    'ppt',
    'pptx',
    'odp',
    'csv',
    'zip',
    'rar',
];

export const PLAN_TO_PUBLIC_NAME = {
    FREE: 'Free',
    PAID: 'Business',
    PRO: 'Pro',
};

export const CONFIG = {
    APP_NAME: {
        ESEMNEAZA: 'eSemneaza.ro',
        QUICKSIGNER: 'QuickSigner.com',
    },
    DEFAULT_LANGUAGE: {
        ESEMNEAZA: 'ro',
        QUICKSIGNER: 'en',
    },
    WEB_SITE_URL: {
        ESEMNEAZA: 'https://www.esemneaza.ro',
        QUICKSIGNER: 'https://www.quicksigner.com',
    },
    TOS_URL: {
        ESEMNEAZA: 'https://www.esemneaza.ro/termeni-si-politici/',
        QUICKSIGNER: 'https://www.quicksigner.com/legal-documents/',
    },
    USER_GUIDE_URL: {
        ESEMNEAZA: 'https://www.esemneaza.ro/ghid-utilizator/',
        QUICKSIGNER: 'https://www.quicksigner.com/user-guide/',
    },
    API_DOC_URL: {
        ESEMNEAZA: 'https://esemneaza.stoplight.io',
        QUICKSIGNER: 'https://quicksigner.stoplight.io',
    },
    PRICES_URL: {
        ESEMNEAZA: 'preturi',
        QUICKSIGNER: 'prices',
    },
    FIREBASE_CONFIG: {
        ESEMNEAZA: {
            apiKey: 'AIzaSyA6AugcUWncmVSll1QqxPldEBjV0lrWxT4',
            authDomain: 'app.esemneaza.ro',
            projectId: 'semn-dev',
            messagingSenderId: '1067797628503',
            appId: '1:1067797628503:web:effd3570ca7d5e89a50512',
            measurementId: 'G-YHP1FBJ2DT',
        },
        QUICKSIGNER: {
            apiKey: 'AIzaSyBsTK0wC8RRsn8r4WTvNR9CizrA21fFw5Q',
            authDomain: 'quicksigner-com-prod.firebaseapp.com',
            projectId: 'quicksigner-com-prod',
            messagingSenderId: '366118636626',
            appId: '1:366118636626:web:e7ff51d22615b4162b238b',
            measurementId: 'G-0M2E3MT2P6',
        },
    },
    // Fill in from GCP Credentials; the button stays hidden while clientId/apiKey are empty.
    GOOGLE_DRIVE: {
        ESEMNEAZA: {
            clientId:
                '1067797628503-plmod60qjm7h7vfflpmohff8giupk6nr.apps.googleusercontent.com',
            apiKey: 'AIzaSyDm0A5NpdBfcpqENr55gx04TcO1yMp-q3A',
            appId: '1067797628503',
        },
        QUICKSIGNER: {
            clientId:
                '366118636626-qmot3bna8fok5n1bih3h5e040ftvlfia.apps.googleusercontent.com',
            apiKey: 'AIzaSyDyM70xrnVi77FXo4axSKykiaGYcnhOikE',
            appId: '366118636626',
        },
    },
    MANIFEST: {
        ESEMNEAZA: 'https://app.esemneaza.ro/manifest-esemneaza.json',
        QUICKSIGNER: 'https://app.quicksigner.com/manifest-quicksigner.json',
    },
    LOGO: {
        ESEMNEAZA: eSemneazaLogo,
        QUICKSIGNER: quickSignerLogo,
    },
    LOGO_HEIGHT: {
        ESEMNEAZA: '25px',
        QUICKSIGNER: '35px',
    },
    META_DESCRIPTION: {
        ESEMNEAZA:
            'Modernizează și accelerează semnarea documentelor. Gratuit. Cu valoare legală. Fără token.',
        QUICKSIGNER:
            'Modernize and accelerate the management and signing of documents.',
    },
    CURRENCY: {
        ESEMNEAZA: 'RON',
        QUICKSIGNER: 'USD',
    },
    DATE_FORMAT: {
        ESEMNEAZA: 'DD/MM/YYYY',
        QUICKSIGNER: 'MM/DD/YYYY',
    },
    DATE_FORMATS: {
        ESEMNEAZA: [
            'DD/MM/YYYY',
            'DD-MM-YYYY',
            'DD.MM.YYYY',
            'MM/DD/YYYY',
            'MM-DD-YYYY',
            'MM.DD.YYYY',
        ],
        QUICKSIGNER: [
            'MM/DD/YYYY',
            'MM-DD-YYYY',
            'MM.DD.YYYY',
            'DD/MM/YYYY',
            'DD-MM-YYYY',
            'DD.MM.YYYY',
        ],
    },
    PHONE_NUMBER_PLACEHOLDER: {
        ESEMNEAZA: '07********',
        QUICKSIGNER: '+*********',
    },
    GTM_ID: {
        ESEMNEAZA: 'GTM-57VFS9QW',
        QUICKSIGNER: 'GTM-T3JSF5X8',
    },
    CONTACT_EMAIL: {
        ESEMNEAZA: 'info@esemneaza.ro',
        QUICKSIGNER: 'contact@quicksigner.com',
    },
};

export const RECAPTCHA_CONTAINER_ID = 'recaptcha-container';
export const PARTNERSTACK_XID_QUERY_PARAM = 'ps_xid';
export const PARTNERSTACK_XID_STORAGE_KEY = 'partnerstack_xid';
export const GCLID_QUERY_PARAM = 'gclid';
export const GCLID_STORAGE_KEY = 'gclid';
export const LINKEDIN_QUERY_PARAM = 'li_fat_id';
export const LINKEDIN_STORAGE_KEY = 'li_fat_id';

export const APP_NAME = CONFIG.APP_NAME[APP];
export const WEB_SITE_URL = CONFIG.WEB_SITE_URL[APP];
export const PRICES_URL = CONFIG.PRICES_URL[APP];
export const FIREBASE_CONFIG = CONFIG.FIREBASE_CONFIG[APP];
export const GOOGLE_DRIVE_CONFIG = CONFIG.GOOGLE_DRIVE[APP];
export const MANIFEST = CONFIG.MANIFEST[APP];
export const LOGO = CONFIG.LOGO[APP];
export const META_DESCRIPTION = CONFIG.META_DESCRIPTION[APP];
export const DEFAULT_LANGUAGE = CONFIG.DEFAULT_LANGUAGE[APP];
export const LOGO_HEIGHT = CONFIG.LOGO_HEIGHT[APP];
export const CURRENCY = CONFIG.CURRENCY[APP];
export const DATE_FORMAT = CONFIG.DATE_FORMAT[APP];
export const DATE_FORMATS = CONFIG.DATE_FORMATS[APP];
export const PHONE_NUMBER_PLACEHOLDER = CONFIG.PHONE_NUMBER_PLACEHOLDER[APP];
export const API_BASE_URL =
    ENV === 'LOCAL' ? 'http://localhost:8080/fe-api' : '/fe-api';
// Bump on backend changes that break older bundles, then raise MIN_CLIENT_VERSION in the backend
export const CLIENT_VERSION = 1;
export const DEFAULT_DOC_NAME = 'document.pdf';
export const TOS_URL = CONFIG.TOS_URL[APP];
export const API_DOC_URL = CONFIG.API_DOC_URL[APP];
export const GTM_ID = CONFIG.GTM_ID[APP];
export const CONTACT_EMAIL = CONFIG.CONTACT_EMAIL[APP];
export const USER_GUIDE_URL = CONFIG.USER_GUIDE_URL[APP];

export const PRIMARY_COLOR = '#0076CC';
export const ACCENT_COLOR = '#CC0076';
